import axios from 'axios';

export const validateEmail = async (queryParams) => {
  const { data } = await axios.post('/users/validate-email', queryParams);

  return data;
};
